
import { useFetchOrdenesCompras } from '@/shared/actions/erp';
import { useCheckPermissions, useTableFilter, useTableServerSideFiltering } from '@/shared/hooks';
import GeneralTable from '@/shared/components/ui/GeneralTable';

import { Grid, IconButton, Tooltip, Typography } from '@mui/material';

import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';

import { EstadosProcesoEnumChoice, gridSizeMdLg12, gridSizeMdLg4, TABLE_CONSTANTS } from '@/shared';
import { PermissionsEnum } from '@/auth/interfaces';
import { OrdenesCompra } from '@/shared/interfaces/erp/compras/ordenes-compra.interface';

import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import { useNavigate } from 'react-router-dom';
import useTableOrdeneCompra from '../../shared/hook/useTableOrdenCompra';
import { useCargarSeriesProductos } from '@/store/erp/productos/useCargarSeriesProductos.store';
import SampleTablePagination from '@/shared/components/ui/SampleTablePagination';
import { AlertSeverityEnum, MaterialTransferido } from '@/shared/interfaces';
import DescriptionIcon from '@mui/icons-material/Description';

import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { useFileDowloadDoc } from '@/shared/hooks/useDownloadFileDoc';
import { useUiStore } from '@/store/ui';
import { SingleButton } from '@/shared/components/ui';
import PhotoSizeSelectActualIcon from '@mui/icons-material/PhotoSizeSelectActual';
import { useState } from 'react';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import { toast } from 'react-toastify';
import {exportExcel,mapOrdenesCompraConcierre} from './ordenesCompraparcialFuncions'



export default function SolicitudOrdenCompraParcialPagina() {
  useCheckPermissions(PermissionsEnum.api_view_ordencompra);
  const navigate = useNavigate();
  const setAlert = useUiStore(s => s.setAlert)
  //store
  const handleCopiarLista = useCargarSeriesProductos(s => s.handleCopiarLista)
  const productos = useCargarSeriesProductos(s => s.productos)
  const paginatedData = useCargarSeriesProductos(s => s.paginatedData)
  const paginationTable = useCargarSeriesProductos(s => s.pagination)
  const setPaginationTable = useCargarSeriesProductos(s => s.setPagination)

  //state
  const [respaldoOpenModal, setRespaldoOpenModal] = useState(false)
  const [urlRevisionSolicitud, setUrlRevisionSolicitud] = useState('')
  const [urlOrdenCompra, setUrlordenCompra] = useState('')
  const [urlRevisorOrden, setUrlRevisorOrden] = useState('')


  /*   console.log('generaorden', urlOrdenCompra)
    console.log('revisaorden', urlRevisorOrden)
    console.log('revisaSolicitud', urlRevisionSolicitud) */
  //const clearSelectedItems = useCargarSeriesProductos(s => s.clearSelectedItems)
  ///hookk
  const { isOpenModal, setIsOpenModal, infoOrdenCompra, infoProducto } = useTableOrdeneCompra()
  const { downloadFile } = useFileDowloadDoc()


  const calcularCantidadPendientes = (productos: MaterialTransferido[]) => {

    const resultado = productos.map((item: MaterialTransferido) => {
      const cantidadAcumulada = Number(item.cantidad_acumulada || 0) + Number(item.cantidad_recibida!)
      const cantidadPendiente = Number(item.cantidad) - cantidadAcumulada;
      return {
        ...item,
        cantidad: Number(item.cantidad),
        stock_actual: String(item.stock_actual),
        cantidad_aprobada: Number(item.cantidad_aprobada),
        cantidad_acumulada: cantidadAcumulada,
        cantidad_pendiente: cantidadPendiente,
        cantidad_recibida: item.cantidad_recibida,
      }
    })
    handleCopiarLista(resultado)

  }


  const {

    pagination,
    searchTerm,
    //onChangeFilter,
    setPagination,
    //cleanFilter,

  } = useTableFilter();


  const { pageIndex, pageSize } = pagination;
  const { columnFilters, setColumnFilters, filterObject } = useTableServerSideFiltering()
  //normalizamos 
  const normalizeFilters = (filters: Record<string, any>) => {
    const result: Record<string, any> = {}
    Object.entries(filters).forEach(([key, value]) => {
      const cleanKey = key.includes('.') ? key.split('.').pop()! : key
      const mappedKey = cleanKey === 'razon_social' ? 'proveedor_razon_social' : cleanKey
      result[mappedKey] = value
    })
    return result
  }
  const { isLoading, data: solicitudPedidosEnAprobadosRes, isRefetching, } = useFetchOrdenesCompras(
    {
      page: pageIndex + 1,
      numero_referencia: searchTerm,
      estado_orden: EstadosProcesoEnumChoice.PARCIAL,
      //es_parcial: ingreso_inventario_data,
      page_size: pageSize,
      ...normalizeFilters(filterObject)
      //...filterObject,
      //filterByState: false,
    });
  ///**********dowload*/
  const handleDowloadRevisionSolicitud = async () => {
    /*   console.log('descarga', urlRevisionSolicitud)
      return; */
    if (!urlRevisionSolicitud)
      return setAlert(true, 'El usuario que realizó la revisión no subió ningun respaldo.', AlertSeverityEnum.info)
    downloadFile({
      url: urlRevisionSolicitud,
      nameFile: 'Respaldo_aprobación_revisorSolicitud',
      //extensionFile: 'pdf'
    })
  }
  ///****funcion para descargar el orden compra */
  const onDownload = (e: string) => {
    if(!e) return toast.error('El archivo PDF no se ha generado.')
    downloadFile({
      url: e,
      nameFile: 'Orden Pedido'
    })
  }
  //********funciones de descargar de respaldo */
  const handleDowloadOrdenCompra = () => {
    ///console.log(urlOrdenCompra)
    if (!urlOrdenCompra)
      return setAlert(true, 'El usuario que genero la orden de compra no subió ningun respaldo.', AlertSeverityEnum.info)
    downloadFile({
      url: urlOrdenCompra,
      nameFile: 'Respaldo_aprobación_OrdenCompra',
      //extensionFile: 'pdf'
    })
  }
  const handleDowloadRevisionOrden = () => {
    //console.log('ordenreviso', urlRevisorOrden)
    if (!urlRevisorOrden)
      return setAlert(true, 'El usuario que reviso la orden de compra no subió ningun respaldo.', AlertSeverityEnum.info)
    downloadFile({
      url: urlRevisorOrden,
      nameFile: 'Respaldo_aprobación_RevisionOrden',
      //extensionFile: 'pdf'
    })

  }

const manejarDescarga = () => {
  exportExcel(mapOrdenesCompraConcierre(paginatedData),"Detalle producto");
};

  //***********************FUNCION QUE VERIFICA EL TIPO DE URL/
  const esPdf = (url: string) => url.toLowerCase().endsWith('.pdf')

  //***********************/
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
      </Grid>
      <Grid item xs={12}>
        <GeneralTable<OrdenesCompra>
          columns={infoOrdenCompra}
          data={solicitudPedidosEnAprobadosRes?.data.data || []}
          /*  data={solicitudPedidosEnAprobadosRes?.data.data.filter(
             item => !item.detalles!.some(producto => Number(producto.cantidad_recibida) > 0)
           ) || []
           } */
          isLoading={isLoading}
          isRefetching={isRefetching}
          // // search
          enableGlobalFilter={false}
          // onGlobalFilterChange={setGlobalFilter}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={solicitudPedidosEnAprobadosRes?.data?.count}
          ///
          enableManualFiltering={true}
          columnFilters={columnFilters}
          onColumnFiltersChange={setColumnFilters}
          enableSorting={false}
          // // actions
          //actionsColumnSize={10}
          // crud
          enableColumnActions={true}
          //enableEditing={false}
          canEdit={false}
          canDelete={false}
          positionActionsColumn='first'

          //acciones
          //actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_MEDIUM}
          actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH}
          showCustomActionBtnSpace={true}
          customActionBtnSpace={(value) => {
            return (
              <>
                <Grid container >
                  <Grid item>
                    <Tooltip title="Descargar" placement={'top'}>
                      <IconButton
                        color='info'
                        onClick={() => {
                          onDownload(value.url_pdf!)
                        }}
                      >
                        <DownloadForOfflineIcon />
                      </IconButton>


                    </Tooltip>

                  </Grid>
                  <Grid item>
                    <Tooltip title="Cerrar Orden" placement={'top'}>
                      <IconButton
                        onClick={() => {
                          //console.log('id', value)
                          //console.log('value', value)
                          calcularCantidadPendientes(value.detalles!)
                          return navigate(`/compras/orden-compras/finalizar/${value.id_orden_compra}`)
                        }}
                      >
                        <AssignmentTurnedInOutlinedIcon />
                      </IconButton>

                    </Tooltip>
                  </Grid>
                  <Grid item>
                    <Tooltip title="Visualizar Respaldo de Aprobación" placement='top'>
                      <IconButton
                        onClick={() => {
                          //console.log(value.urls_imagenes?.urlOrdenRevision)
                          const archivoRevision = value?.solicitud_ingreso_data?.urls_imagenes?.archivoRevision
                          setUrlRevisionSolicitud(archivoRevision!);
                          setUrlordenCompra(value.urls_imagenes?.urlOrden!)
                          setUrlRevisorOrden(value.urls_imagenes?.urlOrdenRevision!)
                          setRespaldoOpenModal(true)
                        }}
                      >
                        <DescriptionIcon />
                      </IconButton>

                    </Tooltip>

                  </Grid>


                </Grid>
              </>
            )
          }}
        />
      </Grid>
      <ScrollableDialogProps
        open={isOpenModal}
        title="Detalle Producto"
        onCloseIcon={() => setIsOpenModal(false)}
        minWidth="60%"
        contentNode={
          <>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                <SampleTablePagination
                  columns={infoProducto}
                  data={paginatedData}
                  rowCount={productos.length}
                  pagination={paginationTable}
                  setPagination={setPaginationTable}

                  //
                    onDownload={manejarDescarga} // Al enviar esto, el botón aparece
                    downloadText="Descargar reporte " // Opcional: cambia el texto del botón
                />
              </Grid>
            </Grid>
          </>
        }
      />
      <ScrollableDialogProps
        open={respaldoOpenModal}
        title='Respaldos de Aprobación'
        onCloseIcon={() => setRespaldoOpenModal(false)}
        minWidth='47%'
        //minHeight='40%'
        contentNode={
          <>
            <Grid container spacing={3}>
              <Grid item xs={12} justifyContent={'center'}>
                {urlRevisionSolicitud || urlOrdenCompra || urlRevisorOrden ? (
                  <Typography variant='h6' fontWeight="bold" color="text.secondary">
                    {'Click para descargar los documentos'}
                  </Typography>

                ) : (
                  <Typography mt={4} color="text.secondary" textAlign={"center"}>
                    {'No existe ningun respaldos'}
                  </Typography>
                )}

              </Grid>
              <Grid item {...gridSizeMdLg12}>
                <Grid container spacing={2}>
                  {urlRevisionSolicitud && (
                    <Grid item {...gridSizeMdLg4}>
                      <SingleButton
                        onClick={handleDowloadRevisionSolicitud}
                        startIcon={esPdf(urlRevisionSolicitud) ? (
                          <PictureAsPdfIcon />
                        ) : (
                          <PhotoSizeSelectActualIcon />
                        )
                        }
                        //startIcon={<PictureAsPdfIcon />}
                        variant='outlined'
                        size={gridSizeMdLg4}
                        label='Revisor Solicitud'
                      />

                    </Grid>

                  )}
                  {urlOrdenCompra && (
                    <Grid item {...gridSizeMdLg4}>
                      <SingleButton
                        onClick={handleDowloadOrdenCompra}
                        ///startIcon={<PictureAsPdfIcon />}
                        startIcon={esPdf(urlOrdenCompra) ? (
                          <PictureAsPdfIcon />
                        ) : (
                          <PhotoSizeSelectActualIcon />
                        )}
                        color='error'
                        variant='outlined'
                        size={gridSizeMdLg4}
                        label='Creador de la Orden'
                      />
                    </Grid>

                  )}
                  {urlRevisorOrden && (
                    <Grid item {...gridSizeMdLg4}>
                      <SingleButton
                        onClick={handleDowloadRevisionOrden}
                        //startIcon={<PictureAsPdfIcon />}
                        startIcon={esPdf(urlRevisorOrden) ? (
                          <PictureAsPdfIcon />
                        ) : (
                          <PhotoSizeSelectActualIcon />
                        )}
                        color='success'
                        variant='outlined'
                        size={gridSizeMdLg4}
                        label=' Revisor de la orden'
                      />
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </>
        }
      />
    </Grid>
  );
}
